import { render, staticRenderFns } from "./elastic-product-list-pagination.vue?vue&type=template&id=3b4c8417&scoped=true"
import script from "./elastic-product-list-pagination.vue?vue&type=script&lang=js"
export * from "./elastic-product-list-pagination.vue?vue&type=script&lang=js"
import style0 from "./elastic-product-list-pagination.vue?vue&type=style&index=0&id=3b4c8417&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c8417",
  null
  
)

export default component.exports